import { z } from 'zod'

export const ReasonForSeekingTreatmentFormSchema = z
  .object({
    HEALTH_QUESTIONNAIRE: z.object({
      PHQ9: z.object({
        QUESTION1: z.number(),
        QUESTION2: z.number(),
        QUESTION3: z.number(),
        QUESTION4: z.number(),
        QUESTION5: z.number(),
        QUESTION6: z.number(),
        QUESTION7: z.number(),
        QUESTION8: z.number(),
        QUESTION9: z.number(),
        TOTAL_SCORE: z.number(),
      }),
      GAD7: z.object({
        QUESTION1: z.number(),
        QUESTION2: z.number(),
        QUESTION3: z.number(),
        QUESTION4: z.number(),
        QUESTION5: z.number(),
        QUESTION6: z.number(),
        QUESTION7: z.number(),
        TOTAL_SCORE: z.number(),
      }),
    }),
    FUNCTIONAL_IMPAIRMENTS: z.object({
      DIFFICULTY_MEETING_EXPECTATIONS: z.boolean(),
      STRUGGLE_WITH_RELATIONSHIPS: z.boolean(),
      NEGLECT_OF_PERSONAL_NEEDS: z.boolean(),
      DIFFICULTY_IN_SLEEP: z.boolean(),
      CHANGE_IN_APPETITE_OR_WEIGHT: z.boolean(),
      IMPAIRED_COGNITIVE_FUNCTIONING: z.boolean(),
      VOLATILE_MOOD_RESPONSES: z.boolean(),
      DIFFICULTY_MANAGING_TASKS: z.boolean(),
      LOSS_OF_INTEREST: z.boolean(),
      OTHER: z.string().min(1).optional(),
    }),
    NARRATIVE: z.string().min(1),
  })
  .superRefine((data, ctx) => {
    const atLeastOneFunctionalImpairmentChecked = !!(
      data.FUNCTIONAL_IMPAIRMENTS.DIFFICULTY_MEETING_EXPECTATIONS ||
      data.FUNCTIONAL_IMPAIRMENTS.STRUGGLE_WITH_RELATIONSHIPS ||
      data.FUNCTIONAL_IMPAIRMENTS.NEGLECT_OF_PERSONAL_NEEDS ||
      data.FUNCTIONAL_IMPAIRMENTS.DIFFICULTY_IN_SLEEP ||
      data.FUNCTIONAL_IMPAIRMENTS.CHANGE_IN_APPETITE_OR_WEIGHT ||
      data.FUNCTIONAL_IMPAIRMENTS.IMPAIRED_COGNITIVE_FUNCTIONING ||
      data.FUNCTIONAL_IMPAIRMENTS.VOLATILE_MOOD_RESPONSES ||
      data.FUNCTIONAL_IMPAIRMENTS.DIFFICULTY_MANAGING_TASKS ||
      data.FUNCTIONAL_IMPAIRMENTS.LOSS_OF_INTEREST ||
      data.FUNCTIONAL_IMPAIRMENTS.OTHER
    )
    if (!atLeastOneFunctionalImpairmentChecked) {
      const fields = Object.keys(data.FUNCTIONAL_IMPAIRMENTS)
      fields.forEach((field) => {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['FUNCTIONAL_IMPAIRMENTS', field],
          message: 'Required',
        })
      })
    }
  })
